import { render, staticRenderFns } from "./mobBusinessDetails.vue?vue&type=template&id=474947ff&scoped=true&"
import script from "./mobBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./mobBusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./mobBusinessDetails.vue?vue&type=style&index=0&id=474947ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474947ff",
  null
  
)

export default component.exports